import React from 'react';
import './Calculator.css';
import { BiCalculator } from 'react-icons/bi';

export default function CalculatorTrigger({ onClick, isOpen }) {
  return (
    <button
      type="button"
      className="calc-trigger btn btn-outline-secondary"
      onClick={onClick}
      title={isOpen ? 'Close calculator' : 'Open calculator'}
      aria-expanded={isOpen}
    >
      <BiCalculator />
    </button>
  );
}
